import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {useEffect, useRef, useState} from "react";


const UploadForm = ({onUpload, count, formats}) => {
    const [dragging, setDragging] = useState(false);

    const drop = useRef(null);
    const drag = useRef(null);

    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = e => {
        e.preventDefault();
        e.stopPropagation();

        setDragging(false);

        // Here, Reading data from either drag or by clicking the upload component
        const files = e.dataTransfer ? [...e.dataTransfer.files] : [...e.target.files];

        // Count validation
        if (count && count < files.length) {
            return;
        }

        // Format validation
        if (formats && files.some(file => !formats.some(format => file.name.toLowerCase().endsWith(format.toLowerCase())))) {
            return;
        }

        // Calling the function passed from the parent
        if (files && files.length) {
            onUpload(files);
        }
    };

    const handleDragEnter = e => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target !== drag.current) {
            setDragging(true);
        }
    };

    const handleDragLeave = e => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target === drag.current) {
            setDragging(false);
        }
    };

    useEffect(() => {
        // Adding events
        const dropCurrent = drop.current;
        dropCurrent.addEventListener("dragover", handleDragOver);
        dropCurrent.addEventListener("drop", handleDrop);
        dropCurrent.addEventListener("dragenter", handleDragEnter);
        dropCurrent.addEventListener("dragleave", handleDragLeave);

        return () => {
            // Removing events
            dropCurrent.removeEventListener("dragover", handleDragOver);
            dropCurrent.removeEventListener("drop", handleDrop);
            dropCurrent.removeEventListener("dragenter", handleDragEnter);
            dropCurrent.removeEventListener("dragleave", handleDragLeave);
        };
    }, []);

    return (
        <div className="drag-drop-custom-forms" ref={drop}>
            {dragging && (
                <div className="drag-custom-forms-wrapper" ref={drag}>
                    Drop Files Here...
                </div>
            )}
            <div className="drag-drop-forms__wrapper">
                <div className="upload-icon-wrapper d-inline">
                    <FileUploadOutlinedIcon
                        sx={{
                            color: "#000",
                            fontSize: "25px",
                            mr: "10px"
                        }}
                    />
                </div>
                Drop a file to attach or&nbsp;
                <label
                    htmlFor="file-input"
                    className="btn btn-link p-0"
                    style={{cursor: "pointer"}}
                >
                    browse
                    <input
                        id="file-input"
                        type="file"
                        className="d-none"
                        onChange={handleDrop}
                    />
                </label>
            </div>
        </div>
    );
};

export default UploadForm;